// The small helpers every file of the FO detail used to define for itself: one copy.
import React from 'react'
import Typography from '@mui/material/Typography'

// A blank value is one the server did not send: null, absent or the empty string. A zero is not blank.
export const isBlank = (value) => value === null || value === undefined || value === ''

// The number a value stands for, or null when it is blank or not a finite number.
export const asNumber = (value) => {
  if (isBlank(value)) return null
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

// §2.2 — the LONG dash stands for an absent value in the cells. One constant, so two characters that
// look the same cannot live side by side.
export const EMPTY_DASH = '—'

// Column header cell of the detail tables — bold, small, uppercase, muted. (The operations table has
// its own, measured header: see `operationColumns.js`.)
export const ColumnHeader = ({ children, align = 'left' }) => (
  <Typography
    variant='caption'
    sx={{ fontWeight: 800, letterSpacing: 0.8, textTransform: 'uppercase', color: 'text.secondary', textAlign: align }}
  >
    {children}
  </Typography>
)
